export type IAgentListDTO = Readonly<{
    id: string,
    name: string,
    loginAs: boolean,
    isChildren: boolean,
    children: AgentList[]
}>


export class AgentList {
    id: string;
    name: string;
    loginAs: boolean;
    isChildren: boolean;
    children: AgentList[] | null;

    constructor(dto: IAgentListDTO) {
        this.children = dto.isChildren ? [] : null;
        this.id = dto.id;
        this.name = dto.name;
        this.isChildren = dto.isChildren;
        this.loginAs = dto.loginAs;
    }

    get listChildren(): AgentList[] | undefined {
        return this.children ?? undefined;
    }

    static sortChildren(items: AgentList[]): void {
        items.sort((a, b) => {
            const nameA = a.name?.toLowerCase();
            const nameB = b.name?.toLowerCase();
            if (nameA && nameB) {
                if (nameA < nameB)
                    return -1;
                if (nameA > nameB)
                    return 1;
            }
            return 0;
        });
    }
}
